import { pdf } from "@react-pdf/renderer";
import { DateTime } from "luxon";
import { useCallback } from "react";

import { ValidatedFoldersPdfDocument } from "src/core/components/folders-list/ValidatedFoldersPdfDocument";
import { useUser } from "src/core/contexts/UserContext";
import { useFolderRiskStatistics } from "src/core/hooks/folders-list/useFolderRiskStatistics";
import { downloadPdfBlob } from "src/core/utils/pdf";

export const useDownloadPdf = () => {
  const { user: currentUser } = useUser();
  const { fetchAndCalculate, isLoading } = useFolderRiskStatistics();

  const downloadValidatedFoldersPdf = useCallback(async () => {
    const { statistics, error } = await fetchAndCalculate();

    if (error) {
      // On remonte l'erreur pour que le composant décide de l'affichage (toast, etc.)
      throw error;
    }

    if (!statistics || !currentUser) {
      throw new Error("Aucune statistique disponible pour générer le PDF.");
    }

    try {
      const blob = await pdf(
        <ValidatedFoldersPdfDocument currentUser={currentUser} statistics={statistics} />
      ).toBlob();

      const today = DateTime.now().toFormat("yyyyMMdd");
      const fileName = `Fiches_LAB_${today}.pdf`;

      downloadPdfBlob(blob, fileName);
    } catch (err: unknown) {
      // On log quand même côté dev

      console.error("[useDownloadValidatedFoldersPdf] Error : ", err);

      if (err instanceof Error) {
        throw err;
      }

      throw new Error("Erreur inconnue lors de la génération du PDF.");
    }
  }, [fetchAndCalculate, currentUser]);

  return { downloadValidatedFoldersPdf, isLoading };
};
